import ReactGA from "react-ga4";

// Screens
import TransferRoutes from "./routes";

ReactGA.initialize(" G-5LX2G0H4CP");

const App = () => {
  return <TransferRoutes/>
};

export default App;
